import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../styles/layout';

function FooterComponent() {
  return (
    <Footer>
      &copy; 2026 Playfair. All rights reserved. &nbsp;|&nbsp;
      <Link to="/privacy" style={{ color: '#e5e7eb', textDecoration: 'underline' }}>
        Privacy Policy
      </Link>
    </Footer>
  );
}

export default FooterComponent;
